import { render, staticRenderFns } from "./EodItems.vue?vue&type=template&id=462223a4&scoped=true&"
import script from "./EodItems.vue?vue&type=script&lang=js&"
export * from "./EodItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462223a4",
  null
  
)

export default component.exports